import _jsx from '@babel/runtime/helpers/jsx';
import { useState } from 'react';
import 'prop-types';
import classnames from 'classnames';
import { Card } from '@andes/card';
import { Accordion } from '@andes/accordion';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
const namespace$1 = "seo-ui-links-list";
const handleClick = (label, tracks, trackEvent) => {
  const {
    melidata_track: melidataTrack
  } = tracks || {};
  const {
    path,
    type,
    event_data: eventData = {}
  } = melidataTrack || {};
  if (melidataTrack && trackEvent) {
    trackEvent({
      path,
      type,
      event_data: _objectSpread(_objectSpread({}, eventData), {}, {
        label
      })
    });
  }
};
const LinksList = _ref => {
  let {
    links = [],
    tracks = {},
    trackEvent
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "__container")
  }, void 0, links.map(_ref2 => {
    let {
      label = "",
      url = ""
    } = _ref2;
    return /*#__PURE__*/_jsx("a", {
      className: "".concat(namespace$1, "__link"),
      href: url,
      onClick: () => handleClick(label, tracks, trackEvent)
    }, label.replace(/\s+/g, ""), label);
  }));
};
const namespace = "seo-ui-dynamic-accordions-links";
const DynamicAccordionsLinks = _ref => {
  let {
    tabs = [],
    tracks = {},
    title = "",
    trackEvent
  } = _ref;
  const [activeIds, setActiveIds] = useState([0]);
  const handleAccordionChange = index => {
    setActiveIds(prevActiveIds => prevActiveIds.includes(index) ? [] : [index]);
  };
  if (tabs.length === 0) return null;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace)
  }, void 0, /*#__PURE__*/_jsx("h3", {
    className: "".concat(namespace, "__title")
  }, void 0, title), /*#__PURE__*/_jsx(Card, {
    className: classnames(namespace),
    shadow: "outline"
  }, void 0, tabs.map((_ref2, i) => {
    let {
      title = '',
      links = []
    } = _ref2;
    return /*#__PURE__*/_jsx(Accordion, {
      title: title,
      showDivider: i + 1 < tabs.length,
      expanded: activeIds.includes(i),
      onChange: () => handleAccordionChange(i)
    }, title, /*#__PURE__*/_jsx(LinksList, {
      links: links,
      tracks: tracks,
      trackEvent: trackEvent
    }));
  })));
};
DynamicAccordionsLinks.displayName = "DynamicAccordionsLinks";
export { DynamicAccordionsLinks as default };
